import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shuffle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function SurpriseButton({ lang }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const go = async () => {
    setBusy(true);
    try {
      const r = await api.get("/books/random", { params: { lang } });
      navigate(`/book/${r.data.book.id}`);
    } catch {
      toast.error("no surprises on this shelf yet");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={go}
      disabled={busy}
      data-testid="surprise-me-btn"
      className="inline-flex items-center justify-center gap-2 font-ui text-xs tracking-caps px-5 h-10 rounded-full bg-primary text-primary-foreground hover:opacity-90 transition-opacity disabled:opacity-60"
    >
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Shuffle className="w-3.5 h-3.5" />}
      surprise me
    </button>
  );
}
